import * as types from './action-types';
import * as endpoints from '../helpers/endpoints';
import searchFormat from '../helpers/search';
import apiRequest from '../helpers/apiRequest';
import { actions } from 'react-redux-form';
import moment from 'moment/moment';
import { unAuthUser } from './index';

export const toggleSearch = () => dispatch => {
    dispatch(toggleSearchUI());
    dispatch(actions.focus('search.name'));
};

export const toggleSearchUI = () => ({
    type: types.TOGGLE_SEARCH
});

export const resetSearch = () => ({
    type: types.CLOSE_SEARCH
});

export const resetSearchResults = () => ({
    type: types.RESET_SEARCH_RESULTS
});

export const closeSearch = () => dispatch => {
    dispatch(resetSearch());
    dispatch(actions.reset('search'));
};

export const resetSearchBtn = () => dispatch => {
    dispatch(actions.reset('search'));
    dispatch(actions.focus('search.name'));
    dispatch(resetSearchResults());
};

export const setDateRange = () => (dispatch, getState) => {
    const startDate = getState().search.startDate;
    const endDate = getState().search.endDate;
    if (
        (startDate !== null && endDate !== null) &
        moment(startDate).isAfter(moment(endDate))
    ) {
        dispatch(actions.change('search.endDate', ''));
    }
};

export const fetchSearchResults = () => ({
    type: types.FETCH_SEARCH_RESULTS
});

export const filteredSearchResults = payload => ({
    type: types.FILTERED_SEARCH_RESULTS,
    payload
});

export const fetchSearchResultsThunk = (name = '') => (dispatch, getState) => {
    let finalURL,
        query,
        filters = getState().search;
    const rssOssType = filters.rssOssType;
    const rssOssCode = `${filters.rssOssCode}`.includes('-')
        ? filters.rssOssCode.split('-')[0]
        : filters.rssOssCode;

    query = `name=${name}`;

    if (Boolean(filters.startDate)) {
        query += `&filters[Event][startDate][gte]=${moment(
            filters.startDate
        ).format('YYYY-MM-DD')}`;
    }

    if (Boolean(filters.endDate)) {
        query += `&filters[Event][startDate][lte]=${moment(filters.endDate)
            .add(1, 'days')
            .format('YYYY-MM-DD')}`;
    }

    if (filters.regionCode) {
        query += `&filters[Event][regionCode][eq]=${filters.regionCode}`;
    }

    if (filters.districtCode) {
        query += `&filters[Event][districtCode][eq]=${filters.districtCode}`;
    }

    if (filters.recruitingStationCode) {
        query += `&filters[Event][recruitingStationCode][eq]=${
            filters.recruitingStationCode
        }`;
    }

    if (rssOssType === 'OSS') {
        query += `&filters[Event][ossCode][eq]=${rssOssCode}`;
    }

    if (rssOssType === 'RSS') {
        query += `&filters[Event][recruitingSubStationCode][eq]=${rssOssCode}`;
    }

    finalURL = `${query}&include[]=RecruitingStation&include[]=RecruitingSubStation&include[]=EventReport&include[]=Category`;
    //If nothing is being pass then set data to empty
    if (!name) {
        dispatch(resetSearchResults());
    } else {
        dispatch(fetchSearchResults());
        apiRequest(
            `${endpoints.EVENT_SEARCH_PATH}?${finalURL}`,
            getState().auth.jwtToken
        )
            .then(data => {
                dispatch(filterSearchResultsThunk(data));
            })
            .catch((status, err) => {
                alert('Due to inactivity, you will be redirected to adportal.');
                dispatch(unAuthUser());
            });
    }
};

export const filterSearchResultsThunk = searchResults => (
    dispatch,
    getState
) => {
    let filters = getState().search;
    let filteredData = {
        data: []
    };

    //Where we filter the results
    filteredData.data = searchResults.data
        .filter(item => {
            //Event Status
            //Event Report Status
            let isMatch = false;

            if (
                filters.eventStatus.length === 0 &&
                filters.eventReportStatus.length === 0
            ) {
                isMatch = true;
            }

            //Event Status
            if (
                filters.hasOwnProperty('eventStatus') &&
                filters.eventStatus.length !== 0
            ) {
                if (
                    item.status === 'Incomplete' &&
                    filters.eventStatus.includes('Event Creation')
                ) {
                    isMatch = true;
                }
                if (
                    item.status === 'Unapproved' &&
                    filters.eventStatus.includes('Event Review')
                ) {
                    isMatch = true;
                }
            }

            //Event Report Status
            if (
                filters.hasOwnProperty('eventReportStatus') &&
                filters.eventReportStatus.length !== 0
            ) {
                if (item.status === 'Approved') {
                    if (
                        item.EventReport.status === 'Pending' &&
                        filters.eventReportStatus.includes(
                            'After Action Pending'
                        )
                    ) {
                        isMatch = true;
                    }

                    if (item.EventReport.status === 'Incomplete') {
                        if (
                            moment(item.startDate) > moment() &&
                            filters.eventReportStatus.includes(
                                'After Action Pending'
                            )
                        ) {
                            isMatch = true;
                        } else {
                            if (
                                filters.eventReportStatus.includes(
                                    'After Action Incomplete'
                                )
                            ) {
                                isMatch = true;
                            }
                        }
                    }
                    if (
                        item.EventReport.status === 'Unapproved' &&
                        filters.eventReportStatus.includes(
                            'After Action Review'
                        )
                    ) {
                        isMatch = true;
                    }
                    if (
                        item.EventReport.status === 'Approved' &&
                        filters.eventReportStatus.includes(
                            'Event/After Action Closed'
                        )
                    ) {
                        isMatch = true;
                    }
                }
            }

            return isMatch;
        })
        .filter(item => {
            //Handheld event (isFromEac)
            let isMatch = false;

            if (
                filters.hasOwnProperty('isFromEac') &&
                filters.isFromEac.length !== 0
            ) {
                if (item.isFromEac === Boolean(filters.isFromEac[0])) {
                    isMatch = true;
                }
            } else {
                isMatch = true;
            }

            return isMatch;
        })
        .filter(item => {
            //Influencer event (isFromPr)
            let isMatch = false;
            let influencerEvents = item.Category.some(
                item => item.name === 'Influencer Event'
            );
            if (
                filters.hasOwnProperty('isFromPr') &&
                filters.isFromPr.length !== 0
            ) {
                if (influencerEvents) {
                    isMatch = true;
                }
            } else {
                isMatch = true;
            }

            return isMatch;
        });
    //After finishing filtering the results and will update the results
    dispatch(filteredSearchResults(filteredData));
};

export const updateDistrictSuccess = payload => ({
    type: types.UPDATE_DISTRICT_SUCCESS,
    payload
});

export const updateRsSuccess = payload => ({
    type: types.UPDATE_RS_SUCCESS,
    payload
});

export const updateRssOssSuccess = payload => ({
    type: types.UPDATE_RSS_OSS_SUCCESS,
    payload
});

export const updateDistrict = e => (dispatch, getState) => {
    const region = typeof e === 'string' ? e : e.target.value;

    dispatch(actions.change('search.districtCode', ''));
    dispatch(updateDistrictSuccess([]));
    dispatch(actions.change('search.recruitingStationCode', ''));
    dispatch(updateRsSuccess([]));
    dispatch(actions.change('search.rssOssCode', ''));
    dispatch(actions.change('search.rssOssType', ''));
    dispatch(updateRssOssSuccess([]));

    apiRequest(
        `${endpoints.LOCATION_DISTRICT_LIST}${region}`,
        getState().auth.jwtToken
    ).then(payload => {
        dispatch(updateDistrictSuccess(payload.data));
    });
};

export const updateRS = e => (dispatch, getState) => {
    const districtCode = typeof e === 'string' ? e : e.target.value;

    dispatch(actions.change('search.recruitingStationCode', ''));
    dispatch(updateRsSuccess([]));
    dispatch(actions.change('search.rssOssCode', ''));
    dispatch(actions.change('search.rssOssType', ''));
    dispatch(updateRssOssSuccess([]));

    apiRequest(
        `${endpoints.LOCATION_RS_LIST}${districtCode}`,
        getState().auth.jwtToken
    ).then(payload => {
        dispatch(updateRsSuccess(payload.data));
    });
};

export const updateRssOss = e => (dispatch, getState) => {
    const rsCode = typeof e === 'string' ? e : e.target.value;
    const userBilletLocation = getState().data.userInfo.Billet.location;

    if (userBilletLocation === 'RSS') {
        apiRequest(
            `${endpoints.LOCATION_RSS_LIST}${rsCode}`,
            getState().auth.jwtToken
        ).then(payload => {
            dispatch(
                updateRssOssSuccess(
                    searchFormat.formatOSSRSSDropdown(payload.data)
                )
            );
        });
    } else if (userBilletLocation === 'OSS') {
        apiRequest(
            `${endpoints.LOCATION_OSS_LIST}${rsCode}`,
            getState().auth.jwtToken
        ).then(payload => {
            dispatch(
                updateRssOssSuccess(
                    searchFormat.formatOSSRSSDropdown(payload.data)
                )
            );
        });
    } else {
        apiRequest(
            `${endpoints.LOCATION_RSS_LIST}${rsCode}`,
            getState().auth.jwtToken
        ).then(payload => {
            let RssList = payload.data;
            apiRequest(
                `${endpoints.LOCATION_OSS_LIST}${rsCode}`,
                getState().auth.jwtToken
            ).then(payload => {
                dispatch(
                    updateRssOssSuccess(
                        searchFormat.formatOSSRSSDropdown(
                            payload.data.concat(RssList)
                        )
                    )
                );
            });
        });
    }
};

export const updateRssOssType = e => (dispatch, getState) => {
    //update here to get the right oss rss type
    const ossRssType = e.target[e.target.selectedIndex].getAttribute(
        'data-type'
    );
    dispatch(actions.change('search.rssOssType', ossRssType));
};



// WEBPACK FOOTER //
// ./src/actions/search.js